































import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class pluginDialog extends Vue {
  @Prop()
  plugInDialogShow!: boolean;

  @Prop()
  handleClose!: Function;

  @Prop()
  inPop!: boolean;

  @Prop()
  close!: Function;

  @Prop()
  isShopify!: boolean;

  public getInstallJumpUrl() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `https://${companyInfo.shop}/admin/themes/current/editor?context=apps&activateAppId=3cb8722a-4436-4e4c-88af-b33e3fe7857a/onsite-javascript`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `https://${companyInfo.shop}/admin/theme/editor/editing/Home?templateName=templates%2Findex.json&activateAppId=5d87df78-5746-4440-b2ec-0336110c2dc6%2Fonsite-javascript`;
      }
    }
    if (this.isShopify) {
      return `https://${companyInfo.shopPre}.myshopify.com/admin/themes/current/editor?context=apps&activateAppId=3cb8722a-4436-4e4c-88af-b33e3fe7857a/onsite-javascript`;
    } else {
      return `https://${companyInfo.shopPre}.myshopline.com/admin/theme/editor/editing/Home?templateName=templates%2Findex.json&activateAppId=5d87df78-5746-4440-b2ec-0336110c2dc6%2Fonsite-javascript`;
    }
    return ``;
  }
  public getType() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `shopify`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `shopline`;
      }
    }
    if (this.isShopify) {
      return `shopify`;
    } else {
      return `shopline`;
    }
    return ``;

  }
  public jumpToInstallUrl() {
    window.open(this.getInstallJumpUrl());
  }
}
